// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titlebar .b-skeleton[data-v-0d5e2028]{width:8em;height:1em}\n", ""]);
// Exports
module.exports = exports;
